import { combineReducers } from 'redux';
import redux from './redux';

const reducer = combineReducers({
  redux
});

export default reducer;
